import { Component,  } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-author',
  templateUrl: './simulation-builder.component.html',
  styleUrls: ['./simulation-builder.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    FormsModule,
  ],
})
export class SimulationBuilderComponent {}
